/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.1.2
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OsrmBannerContent } from "./OsrmBannerContent";
import {
  OsrmBannerContentFromJSON,
  OsrmBannerContentFromJSONTyped,
  OsrmBannerContentToJSON,
  OsrmBannerContentToJSONTyped,
} from "./OsrmBannerContent";

/**
 *
 * @export
 * @interface OsrmBannerInstruction
 */
export interface OsrmBannerInstruction {
  /**
   * How far (in meters) from the upcoming maneuver the instruction should start being displayed.
   * @type {number}
   * @memberof OsrmBannerInstruction
   */
  distanceAlongGeometry: number;
  /**
   *
   * @type {OsrmBannerContent}
   * @memberof OsrmBannerInstruction
   */
  primary: OsrmBannerContent;
  /**
   *
   * @type {OsrmBannerContent}
   * @memberof OsrmBannerInstruction
   */
  secondary?: OsrmBannerContent;
}

/**
 * Check if a given object implements the OsrmBannerInstruction interface.
 */
export function instanceOfOsrmBannerInstruction(
  value: object,
): value is OsrmBannerInstruction {
  if (
    !("distanceAlongGeometry" in value) ||
    value["distanceAlongGeometry"] === undefined
  )
    return false;
  if (!("primary" in value) || value["primary"] === undefined) return false;
  return true;
}

export function OsrmBannerInstructionFromJSON(
  json: any,
): OsrmBannerInstruction {
  return OsrmBannerInstructionFromJSONTyped(json, false);
}

export function OsrmBannerInstructionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OsrmBannerInstruction {
  if (json == null) {
    return json;
  }
  return {
    distanceAlongGeometry: json["distanceAlongGeometry"],
    primary: OsrmBannerContentFromJSON(json["primary"]),
    secondary:
      json["secondary"] == null
        ? undefined
        : OsrmBannerContentFromJSON(json["secondary"]),
  };
}

export function OsrmBannerInstructionToJSON(json: any): OsrmBannerInstruction {
  return OsrmBannerInstructionToJSONTyped(json, false);
}

export function OsrmBannerInstructionToJSONTyped(
  value?: OsrmBannerInstruction | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    distanceAlongGeometry: value["distanceAlongGeometry"],
    primary: OsrmBannerContentToJSON(value["primary"]),
    secondary: OsrmBannerContentToJSON(value["secondary"]),
  };
}
